import { useLocation, useHistory } from 'react-router-dom';
import { getActiveModuleTabs } from '@root/components/falconReact/navbar/navConfig';
import './ModuleTabs.scss';

/**
 * Center-aligned pill tabs for the sibling routes of the active module.
 * Self-gating: renders nothing unless the active module has exactly 2 or 3 child routes,
 * so single-route and 4+-route modules (and every non-module page) are unaffected.
 */
function ModuleTabs() {
  const { pathname, search } = useLocation();
  const history = useHistory();

  // `search` matters for modules whose tabs share one pathname and differ by query param (Inventory).
  const module = getActiveModuleTabs(pathname, search);
  if (!module) return null;

  const { tabs, activeTo } = module;

  return (
    <nav className="ModuleTabs" aria-label="Module sections">
      {tabs.map(tab => {
        const isActive = tab.to === activeTo;
        return (
          <button
            key={tab.to}
            type="button"
            className={`ModuleTabs__Tab${isActive ? ' ModuleTabs__Tab--active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => {
              // Pushing the tab's own `to` intentionally drops deep-link params from the previous
              // view (`bc`, `from`, `severity`, …) so a manual tab switch starts clean.
              if (!isActive) history.push(tab.to);
            }}>
            {tab.name}
            {tab.badge ? <span className="ModuleTabs__Badge">{tab.badge}</span> : null}
          </button>
        );
      })}
    </nav>
  );
}

export default ModuleTabs;
